// src/api/onboardingApi.js

import apiClient from "./client";

export const onboardingApi = {
  getProgress: async (storeRequestId) => {
    const response = await apiClient.get(
      `/onboarding/progress/${storeRequestId}`,
    );
    return response.data;
  },

  updateStep: async (storeRequestId, stepId, status, data = null) => {
    const response = await apiClient.put(
      `/onboarding/step/${storeRequestId}/${stepId}`,
      { status, data },
    );
    return response.data;
  },

  getStepData: async (storeRequestId, stepId) => {
    const response = await apiClient.get(
      `/onboarding/step/${storeRequestId}/${stepId}`,
    );
    return response.data;
  },

  getAllSteps: async () => {
    const response = await apiClient.get("/onboarding/steps");
    return response.data;
  },

  getStoreSteps: async (storeRequestId) => {
    const response = await apiClient.get(`/onboarding/steps/${storeRequestId}`);
    return response.data;
  },

  submitForReview: async (storeRequestId) => {
    const response = await apiClient.post(
      `/onboarding/submit/${storeRequestId}`,
    );
    return response.data;
  },

  // ============================================================
  // DOMAIN SETTINGS - CLIENT ENDPOINT
  // ============================================================

  getDomainSettings: async () => {
    const response = await apiClient.get("/onboarding/domain-settings");
    return response.data;
  },
};
